import { ApiManager } from './apiManager';

export default ApiManager();
